import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';

const messages = defineMessages({
  title: {
    description: 'batchesListPlaceholder.title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'DOg7Ip',
  },
  description: {
    description: 'batchesListPlaceholder.description',
    defaultMessage: 'There are currently no records',
    id: 'drty4h',
  },
  detailsDescription: {
    description: 'batchesListPlaceholder.detailsDescription',
    defaultMessage: 'Once you add shipments to this batch, they will display here',
    id: 'KVeAXi',
  },
  boldStatusView: {
    description: 'batchesListPlaceholder.boldStatusView',
    defaultMessage: 'Batches',
    id: 'bKB6iA',
  },
  boldBatchDetailView: {
    description: 'batchesListPlaceholder.boldBatchDetailView',
    defaultMessage: 'Shipments',
    id: '725SE8',
  },
});

const isOnBatchesGrid = (props) => {
  const {
    location: { pathname },
  } = props;
  return pathname.includes('batches/open/');
};

const BatchesGridPlaceholder = (props) => {
  return isOnBatchesGrid(props) ? (
    <ActionablePlaceholder
      description={<FormattedMessage {...messages.detailsDescription} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldBatchDetailView} />
              </b>
            ),
          }}
        />
      }
    />
  ) : (
    <ActionablePlaceholder
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default BatchesGridPlaceholder;
